import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

const CDropdownSingleSelect = (props) => {
  const labelName = props.labelName;
  const name = props.name;
  let choices = [];
  choices = props.choiceListArray;
  const required = props.required === true ? true : false;
  const placeholder = props.placeholder === undefined ? "" : props.placeholder;
  const defaultValue =
    props.defaultValue === undefined ? "" : props.defaultValue;
  const labelCustomStyle =
    props.labelCustomStyle === undefined ? {} : props.labelCustomStyle;
  const selectCustomStyle =
    props.selectCustomStyle === undefined ? {} : props.selectCustomStyle;
  const optionCustomStyle =
    props.optionCustomStyle === undefined ? {} : props.optionCustomStyle;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassSelect =
    props.customClassSelect === undefined ? "" : props.customClassSelect;
  const customClassOption =
    props.customClassOption === undefined ? "" : props.customClassOption;
  const customClassDiv =
    props.customClassDiv === undefined ? "" : props.customClassDiv;
  const faIcon = props.faIcon === undefined ? "" : props.faIcon;
  const faTitle = props.faTitle === undefined ? "" : props.faTitle;
  const faClass = props.faClass === undefined ? "" : props.faClass;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");

  const checkRequired = (choice) => {
    if (choice.length !== 0) {
      setErrorMsg("");
      setIsValid("");
      props.functionName(name, choice);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please choose one");
    }
  };

  return (
    <>
      <div className={customClassDiv}>
        <label
          className={`form-label ${customClassLabel}`}
          style={labelCustomStyle}
        >
          {labelName}
          <FontAwesomeIcon icon={faIcon} title={faTitle} className={faClass}/>
        </label>
        <select
          className={`form-select ${customClassSelect} ${isValid}`}
          name={name}
          onBlur={(event) => {
            required === true
              ? checkRequired(event.target.value)
              : props.functionName(name, event.target.value);
          }}
          required={required}
          style={selectCustomStyle}
        >
          <option value="" selected>
            {placeholder}
          </option>
          {choices.map((item) => (
            <option
              id={item.id}
              value={item.value}
              className={customClassOption}
              style={optionCustomStyle}
              selected={defaultValue === item.value}
            >
              {item.label}
            </option>
          ))}
        </select>
        <div className="invalid-feedback">{errorMsg}</div>
      </div>
    </>
  );
};

export default CDropdownSingleSelect;
